// A plain image rather than an inline component, so its 75 KB of paths aren't compiled into the app's code.
import noEventsImg from '../../../styles/images/no-events.svg';

import "./styles.scss";

function NoEvents(props) {
    
    return (
        <>
        <div className='no-events'>
            <img src={noEventsImg} alt="" />
            <p>Сохраняйте впечатления, планируйте грандиозные дела.</p>
            <p>Ваши записи появятся здесь.</p>
        </div>

        {/* Without toggleForm, while the form is open, there's nothing to offer. */}
        {props.toggleForm && <div className="no-events-btns">
            <button className="btn btn-green day-layout-btn" onClick={() => props.toggleForm(true)}>Добавить запись</button>
        </div>}
        </>
    )
}

export { NoEvents };